<template>
  <section class="app-body search">
    <div class="app-body_show container-fluid pt-4 pb-5">
      <div class="row">
        <div class="col-md-3">
          <h2 class="t-primary mt-md-3">Search & Discover</h2>
          <div class="d-none d-md-block" v-if="!isLoading && keyword && !hasNoResults">
            <p class="t-xxxlr t-blue t-500 mt-3">{{ totalResults | formatNumber }} results found</p>
            <p class="mt-3 d-flex align-items-center">
              <span>Select a category</span>
              <i class="fa fa-arrow-right t-secondary ml-2" />
            </p>
          </div>
        </div>
        <div class="col-md-9">
          <search-bar :state="searchObject"
            :indexes="indexes"
            :isIndexesLoaded="true"
            :isScopedSearch="false"
            triggerSearchBarFocus
            isMinimal
            @keywordChanged="doSearch"
            @keywordTyped="q => localKeyword = q"
          />

          <template v-if="isEmpty(indexes)">
            <spinner v-if="isEmpty(indexes)" :containerClass="`width--50px min-height--200px`" />
          </template>
          <template v-else>
            <category-overview
              v-if="isLoading || !hasNoResults"
              :categories="indexes"
              :keyword="keyword"
              :localKeyword="localKeyword"
              :isLoading="isLoading"
            />

            <no-result
              v-if="!isLoading && hasNoResults"
              :keyword="keyword"
            />
          </template>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import CategoryOverview from '@/components/search/CategoryOverview'
import NoResult from '@/components/search/NoResult'
import SearchBar from '@/components/search/Bar'
import Spinner from '@/components/shared/Spinner'

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'searchHome',
  metaInfo: {
    titleTemplate: 'Search Home | AcademicLabs'
  },
  components: {
    CategoryOverview,
    NoResult,
    SearchBar,
    Spinner
  },
  data () {
    return {
      isLoading: true,
      localKeyword: ''
    }
  },
  computed: {
    ...mapGetters({
      indexes: 'search/indexes',
      searchObject: 'search/searchObject',
      keyword: 'search/keyword'
    }),
    hasNoResults () {
      return !Object.values(this.indexes).find(i => i.total > 0)
    },
    totalResults () {
      return Object.values(this.indexes).reduce((total, index) => {
        total += index.total
        return total
      }, 0)
    }
  },
  mounted () {
    this.initPage()
  },
  watch: {
    '$route.query' (newVal, oldVal) {
      this.setKeyword(newVal.keyword)
      this.localKeyword = newVal.keyword
      this.getData()
    }
  },
  methods: {
    ...mapActions('search', [
      'fetchCounts',
      'fetchSynonyms',
      'resetSearch',
      'setKeyword'
    ]),
    async getData () {
      this.isLoading = true
      this.fetchSynonyms()
      try {
        await this.fetchCounts()
      } catch (e) {
        // Something went wrong...
      } finally {
        this.isLoading = false
      }
    },
    async initPage () {
      // If there's no keyword, reset the search and set index and fetch counts
      await this.resetSearch()

      // Set keyword if there is one in the query
      const keyword = this.$route.query.keyword
      this.localKeyword = keyword
      if (keyword) {
        await this.setKeyword(keyword)
      }
      this.getData()
    },
    // Push new keyword to $route.query
    doSearch (keyword) {
      if (keyword === this.$route.query.keyword) return
      this.$router.push({ query: { keyword: keyword } })
    }
  }
}
</script>
